import { Component, OnDestroy } from '@angular/core'
import { PipelineType } from '../../shared/model/jobs'
import { Subject, takeUntil, take } from 'rxjs'
import { DialogRef } from '@angular/cdk/dialog'
import { closeJobSelectionDialog$ } from '../../shared/utils/job-selection-dialog-utils'
import { Store } from '@ngrx/store'
import { CaseTreeNode } from '../../state/cases/cases.state'
import { CaseId } from '../../state/case/case.state'
import { selectCases } from '../../state/cases/cases.selectors'
import { selectCaseId } from '../../state/case/case.selectors'

@Component({
    selector: 'app-job-selection-dialog',
    templateUrl: './job-selection-dialog.component.html',
    styleUrls: ['./job-selection-dialog.component.scss'],
})
export class JobSelectionDialogComponent implements OnDestroy {
    PipelineTypeEnum = PipelineType

    chosenPipeline: PipelineType | null = null
    siblingDatasets: string[] | undefined

    private readonly destroy$ = new Subject<void>()

    constructor(store: Store, private readonly dialogRef: DialogRef<void>) {
        closeJobSelectionDialog$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.dialogRef.close()
        })

        store
            .select(selectCases)
            .pipe(take(1))
            .subscribe((cases: CaseTreeNode[]): void => {
                let datasetsInSameFolder: CaseTreeNode[] = []
                store.select(selectCaseId).subscribe(s => {
                    cases.forEach(c => {
                        if (datasetsInSameFolder.length > 0) return
                        if (c.children && c.children!.length > 0) {
                            searchChildren(c.children!, s)
                        }
                    })
                })
                this.siblingDatasets = datasetsInSameFolder.map(d => d.name)

                function searchChildren(children: CaseTreeNode[], caseId: CaseId) {
                    if (!children || children!.length === 0) return
                    for (let i = 0; i < children.length; i++) {
                        if (children[i].id == caseId) {
                            datasetsInSameFolder = children.filter(c => c.is_ready) //filter out folders
                            return
                        } else {
                            searchChildren(children[i].children!, caseId)
                        }
                    }
                }
            })
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    selectPipeline(pipeline: PipelineType): void {
        this.chosenPipeline = pipeline
    }
}
